import React, { useEffect, useState } from 'react';
import API from '../../../utils/axiosInstance';
import '../../../assets/css/Sidebar.css';
import { Link } from 'react-router-dom';

const DoctorSchedule = () => {
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctorId, setSelectedDoctorId] = useState('');
  const [schedules, setSchedules] = useState([]);
  const [formData, setFormData] = useState({
    id: '',
    scheduleDate: '',
    startTime: '',
    endTime: '',
    slotInterval: '',
    unavailableSlots: [],
    appointmentSlots: []
  });
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    API.get('/v1/users')
      .then((response) => setDoctors(response.data.filter(u => u.roles?.some(r => r.name === 'DOCTOR'))))
      .catch((error) => console.error('Error fetching doctors:', error));
  }, []);

  useEffect(() => {
    if (selectedDoctorId) {
      fetchDoctorSchedules();
    }
  }, [selectedDoctorId]);

  const fetchDoctorSchedules = () => {
    API.get(`/v1/doctors/${selectedDoctorId}/schedule/list`)
      .then((response) => setSchedules(response.data))
      .catch((error) => console.error('Error fetching schedules:', error));
  };

  const handleSaveSchedule = () => {
    const payload = {
      doctorId: selectedDoctorId,
      scheduleDate: formData.scheduleDate,
      startTime: formData.startTime,
      endTime: formData.endTime,
      slotInterval: parseInt(formData.slotInterval, 10),
      unavailableSlots: formData.unavailableSlots || [],
      appointmentSlots: formData.appointmentSlots || []
    };

    if (formData.id) {
      API.patch(`/v1/doctors/schedule/${formData.id}`, payload)
        .then(() => {
          fetchDoctorSchedules();
          resetForm();
        })
        .catch((error) => console.error('Error updating schedule:', error));
    } else {
      API.post(`/v1/doctors/${selectedDoctorId}/schedule/create`, payload)
        .then(() => {
          fetchDoctorSchedules();
          resetForm();
        })
        .catch((error) => console.error('Error creating schedule:', error));
    }
  };

  const handleDeleteSchedule = (id) => {
    API.delete(`/v1/doctors/schedule/${id}`)
      .then(() => fetchDoctorSchedules())
      .catch((error) => console.error('Error deleting schedule:', error));
  };

  const handleEditClick = (schedule) => {
    API.get(`/v1/doctors/schedule/${schedule.id}`)
      .then((response) => {
        setFormData(response.data);
        setShowPopup(true);
      })
      .catch((error) => console.error('Error loading schedule:', error));
  };

  const resetForm = () => {
    setFormData({ id: '', scheduleDate: '', startTime: '', endTime: '', slotInterval: '', unavailableSlots: [], appointmentSlots: [] });
    setShowPopup(false);
  };

  return (
    <div className="schedule-container">
      <h4>style={{ color: 'black' }}>Doctor Schedule</h4>

      <select onChange={(e) => setSelectedDoctorId(e.target.value)} value={selectedDoctorId}>
        <option value="">Select Doctor</option>
        {doctors.map((doc) => (
          <option key={doc.id} value={doc.id}>{doc.fullName}</option>
        ))}
      </select>

      {selectedDoctorId && (
        <>
          <Link to="/admin/home/doctor_schedule_create" className="btn btn-color" >Add New</Link>

          <div className="table-wrapper">
            <table className="staff-table tableborder">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Schedule Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Slot Interval (min)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {schedules.map((schedule) => (
                  <tr key={schedule.id} className='datahover'>
                    <td>{schedule.id}</td>
                    <td>{schedule.scheduleDate}</td>
                    <td>{schedule.startTime}</td>
                    <td>{schedule.endTime}</td>
                    <td>{schedule.slotInterval}</td>
                    <td>
                      <button className="btn btn-color btn-sm text-white m-0 px-2 py-2 "><Link to={`/admin/home/doctor_schedule/${schedule.id}/slots`} className="text-white text-decoration-none">
                        View Slots
                      </Link>
                      </button>
                    
                      <button className="btn-color px-3 py-1 mt-0 ms-1" onClick={() => handleEditClick(schedule)}>✏️</button>
                      <button className="bg-danger px-3 py-1 mt-0" onClick={() => handleDeleteSchedule(schedule.id)}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>{formData.id ? 'Edit' : 'Add'} Schedule</h3>
            <input type="date" value={formData.scheduleDate} onChange={(e) => setFormData({ ...formData, scheduleDate: e.target.value })} />
            <input type="time" value={formData.startTime} onChange={(e) => setFormData({ ...formData, startTime: e.target.value })} />
            <input type="time" value={formData.endTime} onChange={(e) => setFormData({ ...formData, endTime: e.target.value })} />
            <input type="number" placeholder="Slot Interval" value={formData.slotInterval} onChange={(e) => setFormData({ ...formData, slotInterval: e.target.value })} />
            <button onClick={handleSaveSchedule}>{formData.id ? 'Update' : 'Add'}</button>
            <button onClick={resetForm}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DoctorSchedule;